import React from "react";
import ServiceItem from "../components/ServiceItem";
import services from "../utils/services";
import StockSection from "../components/StockSection";

function ServicePage() {
  return (
    <div className="tokyo_tm_section">
      <div
        data-aos="fade-right"
        data-aos-duration="1200"
        className="aos-init aos-animate"></div>
      <div className="container">
        <div className="tokyo_tm_services">
          <div className="tokyo_tm_title">
            <div className="title_flex">
              <div className="left">
                <span>Services</span>
                <h3>What I Do</h3>
              </div>
            </div>
          </div>
          <div className="list">
            <ul>
              {services.map((service) => (
                <ServiceItem
                  key={service.id}
                  number={service.id}
                  title={service.title}
                  desc={service.desc}
                  longDesc={service.longDesc}
                />
              ))}
              
            </ul>
          </div>
        </div>
        <StockSection />
      </div>
    </div>
  );
}

export default ServicePage;
